// File: src/App.js
// License: All Rights Reserved
// Copyright (c) 2024 Byron Korir

import React, { useContext, useState} from 'react'
import AddDestinationDetails from './AddDestinationDetails'
import AddDestinationRates from './AddDestinationRates'
import AddDestinationPictures from './AddDestinationPictures'
import { DestinationContext } from '../context/DestinationContext'
import LoadingComponent from '../components/LoadingComponent';

export default function AddAccommodation() {
  const {addDestination, loading} = useContext(DestinationContext)
  const [activeTab, setActiveTab] = useState('details');

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  if (loading){
    return ( <LoadingComponent loadingText={'Adding Destination. Please wait ...'}/>)
  }
  
  return (
    <div className='card ' style={{ backgroundColor: 'rgb(8, 50, 32,1)',minHeight:'100%'}}>
    
      <h2 className="text-center mt-3 mb-4" style={{ fontFamily: 'inknut antiqua', fontWeight: 'bold', color: 'wheat' }}>
        Add Destination(Site)
        </h2>

        <div className='container-fluid card-body border border-success rounded col-md-7' >
          
          <div className="col-lg-12 rounded" style={{ backgroundColor: 'rgb(34, 139, 34,0.6)', padding: '20px' }}>
          <div className="d-flex flex-wrap justify-content-around " >
          <p
              className='rounded px-3 '
              style={{ backgroundColor: activeTab === 'details' ? 'lightgreen' : 'lightgrey', fontSize: '1rem', cursor: 'pointer' }}
              onClick={() => handleTabChange('details')}
            >
              Details
            </p>

            <p
              className='rounded px-3 '
              style={{ backgroundColor: activeTab === 'rates' ? 'lightgreen' : 'lightgrey', fontSize: '1rem', cursor: 'pointer' }}
              onClick={() => handleTabChange('rates')}
            >
              Rates
            </p>
            
            <p
              className='rounded px-3 '
              style={{ backgroundColor: activeTab === 'pictures' ? 'lightgreen' : 'lightgrey', fontSize: '1rem', cursor: 'pointer' }}
              onClick={() => handleTabChange('pictures')}
            >
              Pictures
            </p>
            
           
            
            <div className=' text-center'>
        <button
        onClick={addDestination}
         className='btn btn-primary btn-sm'
          >Add Destination</button>
        </div>
      </div>
          <div className='overflow-auto pt-1 pb-3 mb-0 ' style={{ height: 'fit-content'}}>
            {activeTab === 'details' && <AddDestinationDetails setActiveTab={setActiveTab}/>}
            {activeTab === 'rates' && <AddDestinationRates setActiveTab={setActiveTab}/>}
            {activeTab === 'pictures' && <AddDestinationPictures />}
           
          </div>
          </div>
       
        </div>

    </div>
  )
}

 